import clsx from "clsx";
import React, { useEffect } from "react";
import styles from "./SuccessPage.module.scss";
import useSectionDimensions from "@/hooks/useSectionDimensions";
import { CompareSvg, DownloadSvg, IconReUpload } from "@/assets/icons";
import { FTFlex } from "@/components/flex";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";
import { getFileName, showDownloadSuccessResult } from "@/utils";
import MoreEditButton from "@/components/more-edit-button/MoreEditButton";
import SvgButton from "@/components/svg-button";
import { FitSize, Tooltip } from "@/components";
import Analyse from "@/utils/analyse";
import MoreOperationButton from "@/components/more-operation-button/MoreOperationButton";
import useEffectStore from "@/stores/effectStore";

export default function SuccessPage() {
  const { t } = useTranslation();
  const task = useEffectStore((state) => state.task);
  const [compare, setCompare] = React.useState(false);

  const [showMoreEdit, setShowMoreEdit] = React.useState(false);
  const [showMoreOperation, setShowMoreOperation] = React.useState(false);
  const [originIsLoaded, setOriginIsLoaded] = React.useState(false);
  const [resultIsLoaded, setResultIsLoaded] = React.useState(false);
  const originWidth = useEffectStore(
    (state) => state.fileOptions.uploadFile?.width ?? 1
  );
  const originHeight = useEffectStore(
    (state) => state.fileOptions.uploadFile?.height ?? 1
  );

  const resultWidth = task?.width ?? 1;
  const resultHeight = task?.height ?? 1;
  const {
    width: imgWidth,
    height: imgHeight,
    imgEleRef,
    syncDimensions,
  } = useSectionDimensions();
  useEffect(() => {
    syncDimensions();
  }, []);
  const handleDownload = () => {
    Analyse.getInstance().download("canva_download");
    saveAs(task!.pictureUrl!, getFileName(task!.pictureUrl!));
    Analyse.getInstance().downloadResult("canva_download");
    showDownloadSuccessResult(task!.pictureUrl!);
  };
  const showActive = showMoreEdit || showMoreOperation;
  return (
    <FTFlex
      className={styles.loading_wrapper}
      gap={64}
      direction="column"
      align="center"
      justify="center"
      ref={imgEleRef}
    >
      <div
        className={styles.origin_wrapper}
        style={{
          zIndex: compare ? 1 : 0,
          visibility: compare ? "visible" : "hidden",
          display: compare ? "flex" : "none",
        }}
      >
        <FitSize
          childrenWidth={originWidth}
          childrenHeight={originHeight}
          className={styles.origin_fit}
        >
          <img
            src={task?.originalImageUrl}
            alt=""
            className={clsx(
              styles.origin_img,
              !originIsLoaded && "skeleton_loading"
            )}
            onLoad={() => {
              setOriginIsLoaded(true);
            }}
          />
        </FitSize>
      </div>

      <div
        className={styles.result_wrapper}
        style={{
          display: compare ? "none" : "flex",
        }}
      >
        <FitSize
          childrenWidth={resultWidth}
          childrenHeight={resultHeight}
          className={styles.result_fit}
          innerClassName={styles.result_inner}
        >
          <img
            src={task?.pictureUrl}
            alt=""
            className={clsx(
              styles.result_img,
              !resultIsLoaded && "skeleton_loading"
            )}
            onLoad={() => {
              setResultIsLoaded(true);
            }}
            onError={(e) => {
              if (e.target) {
                (e.target as HTMLImageElement).src = "";
                setTimeout(() => {
                  (e.target as HTMLImageElement).src = task?.pictureUrl ?? "";
                }, 1000);
              }
            }}
          />
          <div
            hidden={!resultIsLoaded}
            className={clsx(
              styles.top_left_component,
              showActive && styles.active
            )}
          >
            {/* <div
              className={styles.tool_btn}
              onClick={() => {
                useEffectStore.getState().selectImage("reupload_photo");
              }}
            >
              <IconReUpload />
            </div> */}
          </div>
          <div
            hidden={!resultIsLoaded}
            className={clsx(
              styles.top_right_component,
              showActive && styles.active
            )}
          >
            <MoreOperationButton
              onOpenChange={(value) => {
                setShowMoreOperation(value);
              }}
            />
            <SvgButton
              className={clsx(styles.component_button, styles.hover_btn)}
              onClick={() => {
                const store = useEffectStore.getState();
                if (task?.form) {
                  store.setCollectionCusInfo({
                    name: task.form.name,
                    preset: task.form.preset,
                    profession: task.form.profession,
                  });
                }
                store.selectImage("reupload_photo");
              }}
            >
              <IconReUpload />
              <Tooltip content={t("reupload_tip")} placement="top"></Tooltip>
            </SvgButton>
            <MoreEditButton
              classNames={styles.hover_btn}
              onOpenChange={(value) => {
                setShowMoreEdit(value);
              }}
            />
            <SvgButton
              className={styles.component_button}
              onClick={handleDownload}
            >
              <DownloadSvg />
              <Tooltip content={t("download-tip")} placement="top"></Tooltip>
            </SvgButton>
          </div>
          <div
            hidden={!resultIsLoaded}
            className={styles.bottom_right_component}
          >
            <button
              className={styles.component_button}
              onMouseDown={() => {
                Analyse.getInstance().featureClick("compare");
                setCompare(true);
                const handleCompare = () => {
                  setCompare(false);
                  document.body.removeEventListener("mouseup", handleCompare);
                  document.body.removeEventListener(
                    "mouseleave",
                    handleCompare
                  );
                };
                document.body.addEventListener("mouseup", handleCompare);
                document.body.addEventListener("mouseleave", handleCompare);
              }}
            >
              <CompareSvg />
              <Tooltip content={t("compare-tip")} placement="top"></Tooltip>
            </button>
          </div>
        </FitSize>
      </div>
    </FTFlex>
  );
}
